var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "28", height: "28", viewBox: "-0.5 -0.5 28 28", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "VRBO"
    ),
    React.createElement("circle", { fill: "#fff", cx: "13", cy: "13", r: "13" }),
    React.createElement(
      "text",
      { fontFamily: "Helvetica", fontSize: "7" },
      React.createElement(
        "tspan",
        { x: "3", y: "15" },
        "VRBO"
      )
    )
  );
});